import { Divider, Box, Typography } from "@mui/material";
import React from "react";

export const UnreadLine: React.VFC = ({ ...props }) => (
  <Box display={"flex"} alignItems={"center"} justifyContent={"center"} px={2} width={"100%"} {...props}>
    <Divider
      sx={{
        backgroundColor: "#1F4266",
        borderBottom: "none",
        height: "1px",
        opacity: "1",
        width: "93%"
      }}
    />
    <Typography color={"#1F4266"} fontSize={"14px"} ml={2}>
      New
    </Typography>
  </Box>
);
